import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

var ByObserver = /*#__PURE__*/function () {
  function ByObserver() {
    _classCallCheck(this, ByObserver);
  }

  _createClass(ByObserver, [{
    key: "update",
    value:
    /* eslint-disable */
    function update() {
      throw new Error('需要被重写');
    }
  }]);

  return ByObserver;
}();

export { ByObserver as default };